import { handleAction } from '@mendeley-internal/lib-js-redux-actions';
import { getCitation } from '../actions/citation';

export default handleAction(getCitation, {
  next(state, { payload, meta: { documentId, style } }) {
    const doc = state[documentId] || {};
    return {
      ...state,
      [documentId]: {
        ...doc,
        [style]: payload
      }
    };
  },

  throw(state, { meta: { documentId, style } }) {
    const doc = state[documentId] || {};
    return {
      ...state,
      [documentId]: {
        ...doc,
        [style]: { error: true, message: 'Citation failed to load' }
      }
    };
  }
}, {});



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/citations.js